import { testIsNonEmptyString } from '../../../../lib/test-and-assert/test-base';
import { userQuestionnaireModalRoute } from './router';
import { csrfManager } from '../../../csrf/csrf-manager';
import { apiRequestManager } from '../../../api/api-request-manager';
import { globalLogger } from '../../../../qaamgo/helper/global-logger';
import { pageNotification } from '../../../../qaamgo/helper/notify';
import { useQuestionnaireModalStore } from '../../../store/modules/questionnaire-modal-store';

class UserQuestionnaireModalHelper {
    get #store() {
        return useQuestionnaireModalStore();
    }

    openOnPage(page) {
        return this.#store.openOnPage(page);
    }

    openProjectUsage() {
        return this.openOnPage(userQuestionnaireModalRoute.PROJECT_USAGE);
    }

    isOpen() {
        return testIsNonEmptyString(this.#store.getOpenPage);
    }

    isSubmitting() {
        return this.#store.getSubmitting;
    }

    async saveProfile(userProfiles) {
        this.#store.setSubmitting(true);

        const data = {
            _profiles: userProfiles,
        };

        try {
            data._csrf = await csrfManager.getCsrfUserProfile();

            const response = await apiRequestManager.postWithCaptcha('api/user-profile', data);
            globalLogger.log('ProjectUsageForm - sending request success');

            return response;
        } catch (e) {
            globalLogger.log('ProjectUsageForm - sending request fail');

            pageNotification.showGenericErrorMessage();

            return Promise.reject();
        } finally {
            this.#store.setSubmitting(false);
        }
    }
}

if (!global.gUserQuestionnaireModalHelper) {
    global.gUserQuestionnaireModalHelper = new UserQuestionnaireModalHelper();
}

/**
 * @type {RegisterPaymentModalHelper}
 */
const userQuestionnaireModalHelper = global.gUserQuestionnaireModalHelper;

export { userQuestionnaireModalHelper };
